// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"83783451","183":"b3d93a31","233":"c44a16e6","453":"b0a8f921","469":"19f95936","827":"d6b9a88e","997":"d50098e5"}[chunkId] + ".chunk.js";
};